import React, { useState, useEffect, useRef } from 'react';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";
import Partnerships from "./Partnerships";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));


function InnerTransformation() {

  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});

  const coreElements = [
    {
      titleKey: 'Self-Awareness & Mindfulness',
      descriptionKey: 'our ability to tune-in and consciously be aware of our own thoughts, emotions, and actions coupled with how our behavior affects others.'
    },
    {
      titleKey: 'Values-based Leadership',
      descriptionKey: 'where leaders align their actions with their core values to guide decision-making and build a culture of authenticity and trust'
    },
    {
      titleKey: 'Emotional Resilience',
      descriptionKey: 'the ability to adapt and bounce back from stress, adversity, and trauma, allowing you to cope with life\'s challenges, manage difficult emotions, and maintain mental well-being'
    },
    {
      titleKey: 'Interconnectedness & Compassion',
      descriptionKey: 'nothing exists in isolation. Acknowledging this connection can foster empathy, compassion, and a sense of shared responsibility for collective well-being.'
    },
    {
      titleKey: 'Purpose and Meaning',
      descriptionKey: 'an intended goal or reason for action (future-oriented), while meaning is the significance or understanding derived from past experiences and existence (past/present-oriented)'
    }
  ];

  const transformationPanels = [
    {
      titleKey: 'Inner Transformation in Education',
      descriptionKey: 'Working with different stakeholders in education to bring mindfulness in education. We aim to provide reactive and proactive initiatives through the following:\n1. Train-the-trainer model for mindfulness to be incorporated into schools and communities\n2. Developing Mindfulness Based Stress Reduction (MBSR) therapy to schools',
      bgImage: 'Group 3022.png',
      mobileImage: 'image 21941.png',
      hasPreLine: true
    },
    {
      titleKey: 'Inner Transformation in Organizations',
      descriptionKey: 'Working with leaders and companies to foster change in their organizational culture that considers all stakeholders and is respectful to nature. The hub will convene events and gatherings to allow business and leaders to share best practices and foster collaborations.',
      bgImage: 'Group 3023.png',
      mobileImage: '95aae87cd2ded08bcfe1a980cbc182d 1.png',
      hasPreLine: false
    }
  ];

  const partnerships = [
    {
      titleKey: 'heart and mind education, vietnam',
      descriptionKey: 'The SEE Learning® program is a comprehensive curriculum for developing Body, Mind, and Spirit based on the science of compassion, promoting social, emotional, and ethical learning in preschool to primary and secondary education worldwide. The program is developed by the Emory University Center for Compassion in the United States.',
      logo: 'Group 3022 (1).png',
      status: 'ongoing',
      url: 'https://heartandmind.edu.vn/'
    },
    {
      titleKey: 'Teach for all, global',
      descriptionKey: "Teach For All (TFA) is an organization made up of locally-rooted, globally informed leaders and staff around the world who support 15,000 teachers in classrooms, 100,000 alumni leaders, and reach millions of children in more than 60 countries around the world. We are supporting TFA to expand their inner development leadership program to Asia-based leaders.\n" +
        "\n",
      logo: 'image 2296.png',
      status: 'ongoing',
      url: 'https://teachforall.org/'
    },
    {
      titleKey: 'BONNEVAUX CENTRE FOR PEACE, France',
      descriptionKey: 'Bonnevaux Centre for Peace is an international meditation and retreat centre of the World Community for Christian Meditation. Via meditation and personal transformation, Bonnevaux fosters social transformation and serves peace and unity among all traditions through dialogue, silence and friendship.\n' +
        '\n' +
        '\n',
      logo: 'image 2291.png',
      status: 'ongoing',
      url: 'https://bonnevauxwccm.org/'
    },
    {
      titleKey: 'Inner Discovery for Impact, Singapore',
      descriptionKey: 'The Inner Discovery for Impact is a community or circle of purpose-led individuals who will convene regularly to share, exchange and co-learn together. This is a journey of reflection and authentic sharing to deepen our insights of this new emerging field, from a place of humility, authenticity and impact.\n' +
        '\n' +
        '\n',
      logo: 'image 2254.png',
      status: 'completed',
      url: ''
    },
    {
      titleKey: 'MYANMAR JESUIT MISSION, Myanmar',
      descriptionKey: 'Our contribution supported two projects:\n' +
        'St Aloysius Gonzaga Institute of Higher Studies (SAG) in Taunggyi: English language institute (advanced English studies, humanities, math, science, and social sciences)\n' +
        'Myanmar Leadership Institute (MLI) in Yangon: Purpose is to form emerging leaders in the fields of education, business, and civil society\n' +
        '\n' +
        '\n',
      logo: 'image 2290.png',
      status: 'completed',
      url: 'https://jesuitmission.org.au/'
    },
    {
      titleKey: 'INTERNATIONAL ZEN ASSOCIATION, Europe',
      descriptionKey: 'The International Zen Association is the oldest and largest Zen association in Europe, with several hundred places of practice (temples, Zen centres, dojos and groups) and a mother temple, La Gendronnière, in France.\n' +
        '\n' +
        '\n',
      logo: 'image 2292.png',
      status: 'completed',
      url: 'https://www.zen-azi.org/en'
    }
  ];

  return (
    <>
      <div className='mt-14 md:mt-24 relative'>
        <img className='hidden md:block w-full' src={imgs['Group 3017.png']}/>
        <img className='md:hidden block w-full' src={imgs['Group 3018.png']}/>

        <div
          className='w-[227px] md:w-[600px] text-center absolute text-lg md:text-5xl font-bold text-white z-1 md:leading-[1.2] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          {
            locale === 'en' ? 'Rebuilding the connections between human and all beings' :
              'Tái kết nối mối quan hệ giữa con người và mọi sự sống'
          }
        </div>
      </div>

      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <div className='text-center mb-2 md:mb-3'>
          <h2 className='text-sm md:text-xl font-bold uppercase'>
            {fm('INNER TRANSFORMATION')}
          </h2>
        </div>
        <div className='max-w-[90%] md:max-w-2xl mx-auto'>
          <p className='text-base text-black md:text-2xl leading-relaxed text-center'>
            {fm('We believe lasting social, environmental, and economic change begins with the transformation of human consciousness.')}
          </p>
        </div>
      </div>

      <div className='block md:hidden'>
        <img src={imgs['image 2252.png']} className='w-full'/>
      </div>
      <div className='bg-white py-2 md:py-8 px-8 md:px-[7.5%]'>
        <h2 className='text-lg md:text-3xl font-bold mb-2 md:mb-4 text-black'>
          {fm('Why Inner Transformation?')}
        </h2>
        <div className='flex flex-col md:flex-row gap-8 md:gap-24 items-start'>
          {/* Text Section - Left */}
          <div className='flex-1 md:flex-[2]'>

            <div className='space-y-4 md:space-y-6 text-sm md:text-lg leading-relaxed text-black'>
              <p>
                {fm('Our civilization has become debased and directionless, leading to catastrophic situations in many aspects of life: worsening mental health issues; ever-increasing inequity and decrease in social mobility; polarizing socio-political conflicts; unprecedented environmental destruction; and worst of all, a hardening of the heart.')}
              </p>
              <p>
                {
                  locale === 'en' ? <>
                    Humanity is at a stage where we need to re-write the source code of our civilization. We believe that
                    without <b>Inner Change and an evolution in Consciousness, no sustainable societal change is possible.</b>
                  </> : <>
                    Nhân loại đang ở thời điểm cần “viết lại mã nguồn” của nền văn minh. Chúng tôi tin rằng nếu không có sự chuyển hóa từ bên trong và sự tiến hóa của ý thức, sẽ không thể có bất kỳ thay đổi xã hội bền vững nào.
                  </>
                }

              </p>
              <p>
                {fm('Inner transformation is the process of cultivating self-awareness, emotional intelligence, ethical grounding, and a deeper sense of purpose—so individuals can become agents of compassionate and conscious change in the world.')}
              </p>
            </div>
          </div>
          {/* Image Section - Right */}
          <div className='flex-1 md:flex-[1] w-full md:w-auto hidden md:block'>
            <img
              src={imgs['Group 29581.png']}
              alt="Who We Are"
              className='w-full h-auto object-cover'
            />
          </div>
        </div>
      </div>

      {/*Our Approach*/}
      <div className='bg-white py-2 md:py-8 px-8 md:px-[7.5%]'>
        <h2 className='text-lg md:text-3xl font-bold mb-2 md:mb-4 text-black'>
          {fm('Our Approach')}
        </h2>

        <div className='space-y-1 md:space-y-3'>
          <p className='text-sm md:text-lg leading-relaxed text-black'>
            {fm('We support all efforts that foster Inner Transformation at the individual level and scale it up to organizations.')}
          </p>

          <p className='text-sm md:text-lg leading-relaxed text-black'>
            {fm('We focus on 5 core elements for this work, which include:')}
          </p>

          <ol className='space-y-1 md:space-y-2 list-none pl-0'>
            {coreElements.map((element, index) => (
              <li key={index} className='text-sm md:text-lg leading-relaxed text-black'>
                <span className='font-bold'>{index+1}. {fm(element.titleKey)}</span>

                <span className='hidden md:inline'>{' - '} {fm(element.descriptionKey)}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>

      {/* Inner Transformation Panels - Desktop */}
      <div className='hidden md:block bg-white py-2 md:py-8 px-8 md:px-[7.5%]'>
        <div className='grid grid-cols-2 gap-6'>
          {transformationPanels.map((panel, index) => (
            <div
              key={index}
              className='group relative bg-[#354402] rounded-2xl px-8 py-12 text-white cursor-pointer overflow-hidden flex flex-col justify-between min-h-[300px] transition-all duration-500'
            >
              <img
                src={imgs[panel.bgImage]}
                alt={fm(panel.titleKey)}
                className='absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500'
              />
              <div className='relative z-10'>
                <div className='text-3xl font-bold mb-4 max-w-[468px]'>
                  {fm(panel.titleKey)}
                </div>
                <div
                  className={`text-base md:text-[20px] leading-relaxed group-hover:opacity-0 transition-opacity duration-300 ${panel.hasPreLine ? 'whitespace-pre-line' : ''}`}
                >
                  {fm(panel.descriptionKey)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Inner Transformation Panels - Mobile */}
      <div className='block md:hidden bg-white py-4 px-5'>
        <div className='space-y-6'>
          {transformationPanels.map((panel, index) => (
            <div
              key={index}
              className='relative rounded-2xl overflow-hidden'
            >
              <img
                src={imgs[panel.mobileImage]}
                alt={fm(panel.titleKey)}
                className='w-full h-auto object-cover'
              />
              <div className='bg-[#F2F2F7] p-3 md:p-6 text-black'>
                <div className='text-lg font-bold mb-2 md:mb-4'>
                  {fm(panel.titleKey)}
                </div>
                <div className={`text-sm leading-relaxed ${panel.hasPreLine ? 'whitespace-pre-line' : ''}`}>
                  {fm(panel.descriptionKey)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/*Partnerships*/}
      <Partnerships partnerships={partnerships} />

      {/* bottom part - Quote section */}
      <div className='relative -mb-1 md:mb-auto md:py-20 px-5 md:px-10 h-[150px] md:h-[400px] flex items-center justify-end'>
        <img
          src={imgs['Group 30091.png']}
          alt="Quote Background"
          className='absolute inset-0 w-full h-[150px] md:h-auto'
        />
        <div className='relative mt-0 z-10 max-w-[205px] md:max-w-2xl mx-auto'>
          <div className='text-xs md:text-2xl font-bold text-black leading-[1.3] md:leading-relaxed text-center'>
            {
              locale === 'en' ?
                <>
                  Peace in the world depends on peace in the heart.
                </> :
                <>
                  Hòa bình thế giới phụ thuộc vào hòa bình trong tâm hồn.
                </>
            }
            <p className='mt-5'>Thầy Thích Nhất Hạnh</p>
          </div>
        </div>
      </div>

    </>
  )
}

export default InnerTransformation;
